export const pingPongRate: number = 1500;
export const heartBeatRate: number = 15000;
